import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close-lg",
  "use": "icon-close-lg-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-close-lg\"><g stroke=\"currentColor\" fill=\"none\"><path d=\"M.5.5l19 19M.5 19.5l19-19\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-close-lg.svg
// module id = 869
// module chunks = 74